import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=497a2b2a&"
import script from "./Configuration.vue?vue&type=script&lang=ts&"
export * from "./Configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports